// @flow

import React, { type Node } from 'react';
import {
  getGatewayVoucherUrl,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { Button } from '@tectonics/look-and-feel/shopify/commons/atoms';

export function SaveToPdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <Button
      type="link"
      as="a"
      target="blank"
      href={getGatewayVoucherUrl(incomingPayment) + '&format=pdf'}
      flat
      outline
      outlineColor="#2397d4"
      style={buttonStyle}
    >
      Guardar voucher en PDF
    </Button>
  );
}

const buttonStyle = {
  color: '#ffffff',
  backgroundColor: '#2397d4',
  fontSize: '14px',
  fontWeight: '700',
  marginTop: '10px',
  borderRadius:'5px',
  display: 'block',
};
